import { cn } from '@/lib/utils'

interface KpiCardProps {
  title: string
  value: string | number
  subtitle?: string
  className?: string
}

export function KpiCard({ title, value, subtitle, className }: KpiCardProps) {
  return (
    <div className={cn('rounded-lg border bg-card p-4 space-y-1', className)}>
      <p className="text-sm text-muted-foreground">{title}</p>
      <p className="text-2xl font-bold tabular-nums">{value}</p>
      {subtitle && <p className="text-xs text-muted-foreground">{subtitle}</p>}
    </div>
  )
}
